var map = {
	"./blog.svg": 982,
	"./cases.svg": 983,
	"./content-program.svg": 984,
	"./data-platform.svg": 985,
	"./docs-support-overview.svg": 986,
	"./events.svg": 987,
	"./features.svg": 988,
	"./for-business.svg": 989,
	"./for-education-and-science.svg": 990,
	"./infrastructure.svg": 991,
	"./insurance-offer.svg": 992,
	"./ml-ai.svg": 993,
	"./partners-catalogue.svg": 994,
	"./prices.svg": 995,
	"./security.svg": 996,
	"./serverless.svg": 997,
	"./solutions-gateway-to-russia.svg": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 981;